/* ActionTypes */
import {
  ADD_TO_ENTITIES, CLEAN_ONE_ENTITY,
  CLEAN_ALL_ENTITIES,
  SEARCH,
  STOP_AUTHENTICATED_SAGAS,
} from './actionTypes';

/* Utils */
import { generateRequestActionCreator } from './generators/actionGenerators';

export const addToEntities = (data) => ({ type: ADD_TO_ENTITIES, payload: data });
export const cleanAllEntities = () => ({ type: CLEAN_ALL_ENTITIES });
export const cleanOneEntity = (data) => ({ type: CLEAN_ONE_ENTITY, payload: data });
export const search = generateRequestActionCreator((query, count) => ({
  type: SEARCH,
  payload: { query, count },
}));

export const stopAuthenticatedSagas = () => ({
  type: STOP_AUTHENTICATED_SAGAS,
});
